import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=435fbb0e"
import script from "@/js/downLoad.ts?vue&type=script&lang=ts&external"
export * from "@/js/downLoad.ts?vue&type=script&lang=ts&external"
import style0 from "./Download.vue?vue&type=style&index=0&id=435fbb0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports